
{
  "familyId": "SWW-BN-VD-KORT",
  "questions": [
    {
      "id": "SWW-BN-VD-KORT-001",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'de ... auto' (verbranden → als bijvoeglijk naamwoord)?",
      "context": "Na de brand kijkt de buurman op straat: 'Wat een ___ auto staat daar nog!'",
      "options": ["verbrande", "verbranden", "verbrandde", "verbrandene"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "BN van VD: cluster nd houdt de klank al kort", "content": "Voltooid deelwoord + e = bijvoeglijk naamwoord. De 'a' in 'verbrand' is een KORTE klank — maar het medeklinkercluster 'nd' houdt die klank al kort. Daarom hoef je de d NIET te verdubbelen: verbrand + e = verbrande. Checkstrategie: na een korte klinker + twee medeklinkers (nd, ld, nk) hoeft er geen extra verdubbeling.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_from_past_participle_cluster",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Stappenplan VD → bijvoeglijk naamwoord: (1) Bepaal het VD: verbranden → verbrand. (2) Luister naar de klinker: 'a' in 'verbrand' is KORT. (3) Speciale regel: na de korte 'a' staan al twee medeklinkers (n + d) — dat cluster houdt de klank al kort. Geen extra verdubbeling nodig. (4) verbrand + e = verbrande. Vergelijk: 'verwende' (cluster nd) en 'gebruikte' (cluster kt) werken net zo.",
        "solutionSteps": [
          "Stap 1 — Bepaal het VD: verbranden → verbrand",
          "Stap 2 — Luister naar de klinker: 'verbrand' heeft een KORTE 'a'",
          "Stap 3 — Cluster 'nd' (twee medeklinkers) houdt de klank al kort → geen verdubbeling nodig",
          "Stap 4 — verbrand + e = verbrande",
          "Check: vergelijk met 'verwende' — ook cluster nd, dus geen extra verdubbeling"
        ],
        "distractorExplanations": {
          "0": "Correct! Cluster 'nd' houdt de korte 'a' al kort → gewoon + e = verbrande.",
          "1": "Je dacht waarschijnlijk dat je het hele werkwoord als bijvoeglijk naamwoord kunt gebruiken. Maar 'verbranden' is de infinitief. Als bijvoeglijk naamwoord gebruik je het voltooid deelwoord + e: verbrande. Onthoud: VD + e = bijvoeglijk naamwoord.",
          "2": "Heel logisch dat je dit dacht — bij een korte klank verdubbel je vaak. Maar hier staat al een cluster 'nd' (twee medeklinkers) na de 'a'. Dat cluster houdt de klank al kort, dus extra verdubbeling is niet nodig. Onthoud: korte klank + cluster (nd, ld, nk) → géén verdubbeling.",
          "3": "Je dacht waarschijnlijk dat bijvoeglijke naamwoorden -ene krijgen. Maar 'verbrandene' is te lang. De regel is simpel: voltooid deelwoord + e = verbrande. Onthoud: alleen + e, geen extra lettergrepen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.bn-infinitief-gebruikt", "label": "Infinitief gebruikt in plaats van VD + e", "optionIndex": 1 },
          { "id": "sww.bn-cluster-verdubbeld", "label": "Verdubbeling toegepast hoewel cluster (nd) klank al kort houdt", "optionIndex": 2 },
          { "id": "sww.bn-ene-toegevoegd", "label": "Verouderde -ene-uitgang toegevoegd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-002",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "context": "Mees laat haar werkstuk zien: 'Welke zin uit mijn tekst staat helemaal goed?'",
      "options": ["De geverfde muur ziet er mooi uit.", "De geverfden muur ziet er mooi uit.", "De geverfdde muur ziet er mooi uit.", "De geverfte muur ziet er mooi uit."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "BN van VD: lange klank niet verdubbelen", "content": "Voltooid deelwoord + e = bijvoeglijk naamwoord. 'Geverfd' heeft een lange 'e' → geverfde (niet geverfdde). Verdubbel NIET bij een lange klank. Checkstrategie: 'de geverfdde muur' klinkt te kort — fout.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_from_past_participle_geverfd",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Stappenplan: (1) Bepaal het VD: verven → geverfd. (2) Luister naar de klinker: 'e' in 'geverfd' is LANG. (3) Regel: lange klank → gewoon + e, geen verdubbeling. (4) geverfd + e = geverfde. Checkstrategie: lees hardop 'de geverfde muur' (klinkt natuurlijk) vs. 'de geverfdde muur' (klinkt te kort/onnatuurlijk).",
        "solutionSteps": [
          "Stap 1 — Bepaal het VD: verven → geverfd",
          "Stap 2 — Luister naar de klinker: 'geverfd' heeft een lange 'e'",
          "Stap 3 — Regel: lange klinker → gewoon + e",
          "Stap 4 — geverfd + e = geverfde",
          "Check: 'geverfdde' heeft dubbele d — klinkt te kort, fout"
        ],
        "distractorExplanations": {
          "0": "Correct! Lange klank → gewoon + e: geverfde.",
          "1": "Je dacht waarschijnlijk dat het -en krijgt. Maar 'geverfden' lijkt op een verouderde meervoudsvorm. Bijvoeglijke naamwoorden krijgen alleen -e: geverfde. Onthoud: VD + e, niet VD + en.",
          "2": "Je dacht waarschijnlijk dat je de 'd' moet verdubbelen. Maar de 'e' in 'geverfd' is een lange klank, dus geen verdubbeling. Onthoud: lange klank → NIET verdubbelen.",
          "3": "Je dacht waarschijnlijk dat de kofschip-regel geldt. Maar het voltooid deelwoord is 'geverfd' (met d), niet 'geverft'. Als bijvoeglijk naamwoord: geverfd + e = geverfde. Onthoud: gebruik het VD als basis, niet de stam."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.bn-en-toegevoegd", "label": "Verouderde -en-uitgang toegevoegd", "optionIndex": 1 },
          { "id": "sww.bn-lange-klank-verdubbeld", "label": "Medeklinker verdubbeld bij lange klank", "optionIndex": 2 },
          { "id": "sww.bn-kofschip-misapplied", "label": "Kofschip toegepast op VD (geverft i.p.v. geverfd)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-003",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'het ... kind' (verwennen → als bijvoeglijk naamwoord)?",
      "context": "Tante kijkt op de bank: 'Wat een ___ kind is dat toch.'",
      "options": ["verwende", "verwennde", "verwennen", "verwend"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Korte vs. lange klank — cluster nd", "content": "Het VD van 'verwennen' is 'verwend'. De 'e' in 'verwend' is KORT, maar het medeklinkercluster 'nd' houdt de klank al kort — je hoeft de 'n' niet te verdubbelen. Dus: verwend + e = verwende.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_short_vowel_cluster",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Stappenplan: (1) Bepaal het VD: verwennen → verwend. (2) Luister naar de klinker: 'e' in 'verwend' is KORT. (3) Speciaal geval: het cluster 'nd' houdt de korte klank al kort, dus geen verdubbeling van de n. (4) verwend + e = verwende. Checkstrategie: 'verwennde' zou een dubbele n betekenen die niet nodig is — clusterregel zorgt al voor de korte klank.",
        "solutionSteps": [
          "Stap 1 — Bepaal het VD: verwennen → verwend",
          "Stap 2 — Luister naar de klinker: korte 'e'",
          "Stap 3 — Speciale regel: cluster 'nd' houdt klank kort → géén verdubbeling nodig",
          "Stap 4 — verwend + e = verwende",
          "Check: 'verwennde' heeft overbodige dubbele n"
        ],
        "distractorExplanations": {
          "0": "Correct! Het medeklinkercluster 'nd' houdt de korte klank al kort: verwende.",
          "1": "Je dacht waarschijnlijk dat je de 'n' moet verdubbelen bij een korte klank. Maar het cluster 'nd' houdt de klank al kort — extra verdubbeling is niet nodig. Onthoud: bij een medeklinkercluster (nd, ld, nk, etc.) hoef je niet te verdubbelen.",
          "2": "Je dacht waarschijnlijk dat je de infinitief als bijvoeglijk naamwoord kunt gebruiken. Maar 'verwennen' is het hele werkwoord. Gebruik het VD + e: verwend + e = verwende. Onthoud: VD + e = bijvoeglijk naamwoord.",
          "3": "Je dacht waarschijnlijk dat het VD zonder -e al als bijvoeglijk naamwoord kan. Maar vóór een zelfstandig naamwoord krijgt het bijvoeglijk naamwoord altijd -e: 'het verwende kind', niet 'het verwend kind'. Onthoud: bijvoeglijk naamwoord vóór znw = altijd + e."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.bn-cluster-verdubbeld", "label": "Verdubbeling toegepast hoewel cluster (nd) klank al kort houdt", "optionIndex": 1 },
          { "id": "sww.bn-infinitief-gebruikt", "label": "Infinitief gebruikt in plaats van VD + e", "optionIndex": 2 },
          { "id": "sww.bn-e-vergeten", "label": "Buigings-e vergeten vóór znw", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-004",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Welk bijvoeglijk naamwoord is FOUT geschreven?",
      "context": "Tijdens een spellingoefening kijk je naar vier zinnen — drie zijn goed, één is fout.",
      "options": ["de gestreeptte kat", "de gebroken vaas", "de gestolen fiets", "de gesloten deur"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Verdubbeling controleren", "content": "Bij een lange klank: NIET verdubbelen. 'Gestreept' heeft een lange 'ee' → gestreepte (niet gestreeptte). De andere woorden zijn sterke VD's die op -en eindigen en geen -e nodig hebben. Checkstrategie: spreek hardop uit — verdubbeling klinkt korter.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_error_detection",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Stappenplan voor elke optie: (1) Bepaal het VD. (2) Klank lang of kort? (3) Verdubbeling correct toegepast? 'Gestreeptte' is fout: VD = gestreept, 'ee' is LANG → mag niet verdubbelen → moet gestreepte zijn. De andere woorden zijn correct: 'gebroken', 'gestolen' en 'gesloten' zijn sterke VD's die al op -en eindigen.",
        "solutionSteps": [
          "Stap 1 — Controleer elk woord: VD-vorm + verdubbeling",
          "Gestreeptte → VD gestreept, ee = lang → dubbele t = FOUT",
          "Correct: gestreept + e = gestreepte (lange klank, niet verdubbelen)",
          "De andere drie zijn sterke VD's op -en: correct",
          "Check: 'gestreepte kat' klinkt natuurlijk; 'gestreeptte' klinkt te kort"
        ],
        "distractorExplanations": {
          "0": "Correct gevonden! 'Gestreeptte' is fout — de 'ee' is lang, dus geen verdubbeling: gestreepte.",
          "1": "Je dacht waarschijnlijk dat 'gebroken' fout is. Maar 'gebroken' is een sterk voltooid deelwoord dat al op -en eindigt. Het is correct als bijvoeglijk naamwoord: 'de gebroken vaas'. Onthoud: sterke VD's op -en hoeven geen extra -e.",
          "2": "Je dacht waarschijnlijk dat 'gestolen' fout is. Maar 'gestolen' is een sterk VD op -en. Het is correct: 'de gestolen fiets'. Onthoud: sterke VD's op -en zijn al bijvoeglijk naamwoorden.",
          "3": "Je dacht waarschijnlijk dat 'gesloten' fout is. Maar 'gesloten' is een sterk VD op -en. Het is correct: 'de gesloten deur'. Onthoud: sterke VD's op -en hoeven geen extra -e."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.bn-sterke-vd-als-fout", "label": "Sterk VD op -en aangezien als fout", "optionIndex": 1 },
          { "id": "sww.bn-sterke-vd-als-fout", "label": "Sterk VD op -en aangezien als fout", "optionIndex": 2 },
          { "id": "sww.bn-sterke-vd-als-fout", "label": "Sterk VD op -en aangezien als fout", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-005",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je: 'de ... taart' (bakken → als bijvoeglijk naamwoord)?",
      "context": "Oma haalt een taart uit de oven en zegt: 'Smaakt de ___ taart al?'",
      "options": ["gebakken", "gebakte", "gebakkene", "gebakke"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Sterke VD's op -en", "content": "Sommige werkwoorden hebben een sterk VD dat op -en eindigt: bakken → gebakken. Deze VD's zijn al bijvoeglijk naamwoord: 'de gebakken taart'. Geen extra -e nodig. Checkstrategie: vergelijk met 'de gebroken vaas', 'de gestolen fiets'.", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_strong_participle",
      "variantIndex": 5,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Stappenplan: (1) Bepaal het VD: bakken → gebakken (sterk werkwoord — let op: NIET 'gebakt' volgens kofschip, maar 'gebakken' met -en). (2) Sterke VD's op -en zijn al direct bruikbaar als bijvoeglijk naamwoord. (3) Geen extra -e nodig: 'de gebakken taart'. Checkstrategie: vergelijk met andere sterke VD's: 'de gebroken vaas', 'de gestolen fiets', 'de gesloten deur'.",
        "solutionSteps": [
          "Stap 1 — Bepaal het VD: bakken → gebakken (sterk werkwoord)",
          "Stap 2 — 'Gebakken' eindigt op -en → al bruikbaar als bijvoeglijk naamwoord",
          "Stap 3 — Geen extra -e nodig: 'de gebakken taart'",
          "Check: vergelijk met 'de gebroken vaas', 'de gestolen fiets' (ook sterk)"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Gebakken' is een sterk VD op -en en is al bijvoeglijk naamwoord.",
          "1": "Je dacht waarschijnlijk dat het VD 'gebakt' is (kofschip). Maar 'bakken' is een sterk werkwoord: gebakken (niet gebakt). Onthoud: sterk VD = stamverandering + -en (bakken → gebakken, breken → gebroken).",
          "2": "Je dacht waarschijnlijk dat je -ene moet toevoegen. Maar 'gebakkene' bestaat niet. Sterke VD's op -en zijn al bijvoeglijk naamwoord zonder extra uitgang. Onthoud: gebakken = al klaar.",
          "3": "Je dacht waarschijnlijk dat je de -n kunt weglaten. Maar 'gebakke' is geen correct woord. Het sterke VD is 'gebakken' — gebruik het volledig. Onthoud: sterke VD's op -en blijven onveranderd."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.bn-sterk-als-zwak", "label": "Sterk werkwoord behandeld als zwak (kofschip → gebakt)", "optionIndex": 1 },
          { "id": "sww.bn-ene-toegevoegd", "label": "Verouderde -ene-uitgang toegevoegd", "optionIndex": 2 },
          { "id": "sww.bn-eind-n-weggelaten", "label": "Eind-n weggelaten van sterk VD", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-BN-VD-KORT-006",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "matching",
      "question": "Koppel elk werkwoord aan het juiste bijvoeglijk naamwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "verbranden", "right": "verbrande" },
          { "left": "stelen", "right": "gestolen" },
          { "left": "verwennen", "right": "verwende" },
          { "left": "strepen", "right": "gestreepte" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "VD → bijvoeglijk naamwoord", "content": "Zwak VD + e: verbranden → verbrand → verbrande. verwennen → verwend → verwende. strepen → gestreept → gestreepte. Sterk VD op -en: stelen → gestolen (al bijvoeglijk naamwoord).", "icon": "lightbulb"}, "showWhen": "wrong"}],
      "conceptId": "adjective_matching_overview",
      "variantIndex": 6,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "verbranden → verbrand + e = verbrande (lange 'a', geen verdubbeling). stelen → gestolen (sterk VD op -en, al bijvoeglijk naamwoord). verwennen → verwend + e = verwende (cluster 'nd' houdt klank kort). strepen → gestreept + e = gestreepte (lange 'ee', geen verdubbeling).",
        "solutionSteps": [
          "Stap 1 — verbranden → VD: verbrand → + e = verbrande",
          "Stap 2 — stelen → VD: gestolen (sterk, al bijvoeglijk naamwoord)",
          "Stap 3 — verwennen → VD: verwend → + e = verwende",
          "Stap 4 — strepen → VD: gestreept → + e = gestreepte"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application"
      }
    },
    {
      "id": "SWW-BN-VD-KORT-007",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "fill_in",
      "question": "Vul in: de ... (verbranden → bijvoeglijk naamwoord) muur was nog warm.",
      "correctAnswer": "verbrande",
      "data": {
        "acceptedAnswers": ["verbrande"],
        "placeholder": "bijvoeglijk naamwoord...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "BN van VD met cluster nd", "content": "Verbranden is een zwak werkwoord: VD = verbrand. De 'a' is KORT, maar het cluster 'nd' houdt de klank al kort — dus geen extra verdubbeling: verbrand + e = verbrande.", "icon": "lightbulb" } }
      ],
      "conceptId": "bn_vd_fill_in_verbrande",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Stap 1: VD van verbranden = verbrand. Stap 2: 'a' is kort, maar het cluster 'nd' (n + d) houdt de klank al kort → geen verdubbeling nodig. Stap 3: verbrand + e = verbrande. De verbrande muur was nog warm.",
        "solutionSteps": [
          "Stap 1 — VD: verbranden → verbrand",
          "Stap 2 — Cluster 'nd' houdt korte 'a' al kort → geen verdubbeling",
          "Stap 3 — verbrand + e = verbrande"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application"
      }
    },
    {
      "id": "SWW-BN-VD-KORT-008",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "fill_in",
      "question": "Vul in: het ... (verwennen → bijvoeglijk naamwoord) kind huilde toen het cadeau weg was.",
      "correctAnswer": "verwende",
      "data": {
        "acceptedAnswers": ["verwende"],
        "placeholder": "bijvoeglijk naamwoord...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "BN van VD met cluster", "content": "Verwennen is een zwak werkwoord: VD = verwend. Cluster 'nd' houdt klank al kort → geen verdubbeling. Verwend + e = verwende.", "icon": "lightbulb" } }
      ],
      "conceptId": "bn_vd_fill_in_verwende",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Stap 1: VD van verwennen = verwend. Stap 2: cluster 'nd' houdt klank kort → geen verdubbeling. Stap 3: verwend + e = verwende. Het verwende kind huilde.",
        "solutionSteps": [
          "Stap 1 — VD: verwennen → verwend",
          "Stap 2 — Cluster 'nd' → geen verdubbeling",
          "Stap 3 — verwend + e = verwende"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application"
      }
    },
    {
      "id": "SWW-BN-VD-KORT-009",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "fill_in",
      "question": "Vul in: de ... (bakken → bijvoeglijk naamwoord) vis was heerlijk.",
      "correctAnswer": "gebakken",
      "data": {
        "acceptedAnswers": ["gebakken"],
        "placeholder": "bijvoeglijk naamwoord...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk VD op -en", "content": "Bakken is een sterk werkwoord: VD = gebakken. Sterke VD's op -en worden direct als bijvoeglijk naamwoord gebruikt: de gebakken vis.", "icon": "lightbulb" } }
      ],
      "conceptId": "bn_vd_fill_in_gebakken",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Stap 1: VD van bakken = gebakken (sterk werkwoord). Stap 2: sterke VD op -en → al bijvoeglijk naamwoord. Stap 3: geen extra -e: de gebakken vis.",
        "solutionSteps": [
          "Stap 1 — VD: bakken → gebakken (sterk)",
          "Stap 2 — Sterk VD op -en → al bijvoeglijk naamwoord",
          "Stap 3 — Geen extra -e: de gebakken vis"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application"
      }
    },
    {
      "id": "SWW-BN-VD-KORT-010",
      "familyId": "SWW-BN-VD-KORT",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "bijvoeglijk_naamwoord",
      "subSkill": "bn_klinker_weglating",
      "questionType": "error_spotting",
      "question": "Vind de spelfouten bij de bijvoeglijk gebruikte voltooid deelwoorden.",
      "correctAnswer": null,
      "data": {
        "text": "Het gestreeptte shirt lag naast de gewastte broek. De gebroken vaas stond op de verbrandde tafel.",
        "errors": [
          { "word": "gestreeptte", "position": 1, "correction": "gestreepte", "explanation": "'Gestreept' heeft een lange ee-klank. Bij een lange klinker: geen verdubbeling van de t. Gestreept + e = gestreepte." },
          { "word": "gewastte", "position": 5, "correction": "gewassen", "explanation": "Wassen is een sterk werkwoord: VD = gewassen. Sterke VD's op -en zijn al bijvoeglijk naamwoord." },
          { "word": "verbrandde", "position": 12, "correction": "verbrande", "explanation": "'Verbrand' heeft een KORTE a, maar het cluster 'nd' (n + d) houdt die klank al kort. Geen extra verdubbeling nodig: verbrand + e = verbrande." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Wanneer NIET verdubbelen", "content": "Twee gevallen waarin je NIET verdubbelt: (1) lange klinker (gestreept → gestreepte). (2) korte klinker met cluster ervan (verbrand → verbrande, want 'nd' houdt de klank al kort).", "icon": "lightbulb" } }
      ],
      "conceptId": "bn_vd_error_spotting",
      "variantIndex": 10,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Stappenplan per woord: check klinker (lang/kort) + sterk/zwak VD + verdubbeling. Drie fouten: 1) 'gestreeptte' → gestreepte (lange ee, geen verdubbeling). 2) 'gewastte' → gewassen (sterk VD op -en). 3) 'verbrandde' → verbrande (korte a + cluster 'nd' → cluster houdt al kort, dus geen verdubbeling). 'Gebroken' is correct — sterk VD op -en.",
        "solutionSteps": [
          "Stap 1 — Check elke bijvoeglijke VD: klinker lang of kort?",
          "Stap 2 — Lange klinker → geen verdubbeling (gestreept → gestreepte)",
          "Stap 3 — Korte klinker + cluster (nd, ld, nk) → óók geen verdubbeling (verbrand → verbrande)",
          "Stap 4 — Sterk VD op -en → al klaar, geen -e nodig (gewassen)",
          "gestreeptte → gestreepte, gewastte → gewassen, verbrandde → verbrande"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis"
      }
    }
  ]
}
